import React from 'react';
export function Pricing() {
  const includes = ['E-book completo El Código del Sueño Profundo', 'Protocolo de 14 días paso a paso', 'Guía de alimentación para el sueño', 'Las 3 técnicas de respiración nocturna', 'Plan de mantenimiento permanente', 'Descarga inmediata en PDF'];
  return <section id="pricing" className="bg-white py-24 scroll-mt-20" data-id="element-92">
      <div className="max-w-4xl mx-auto px-4" data-id="element-93">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-text text-center mb-12" data-id="element-94">
          Tu inversión para dormir mejor esta noche
        </h2>

        <div className="max-w-lg mx-auto bg-white border-2 border-primary rounded-3xl p-8 md:p-10 shadow-xl relative overflow-hidden" data-id="element-95">
          <div className="absolute top-0 left-0 w-full h-2 bg-primary" data-id="element-96"></div>

          <div className="text-center mb-8" data-id="element-97">
            <div className="text-gray font-medium text-lg line-through mb-2" data-id="element-98">
              $27
            </div>
            <div className="text-6xl font-bold text-primary mb-2" data-id="element-99">$9.99</div>
            <p className="text-secondary font-bold" data-id="element-100">
              Pago único — Descarga inmediata
            </p>
          </div>

          <div className="space-y-4 mb-10" data-id="element-101">
            {includes.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-102">
                <span className="text-accent mt-0.5" data-id="element-103">✅</span>
                <span className="text-text font-medium" data-id="element-104">{item}</span>
              </div>)}
          </div>

          <button className="w-full bg-primary text-white py-4 rounded-full font-bold text-lg hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5 mb-6" data-id="element-105">
            SÍ, QUIERO DORMIR MEJOR — $9.99 &rarr;
          </button>

          <div className="text-center space-y-4" data-id="element-106">
            <p className="text-sm font-bold text-text/80" data-id="element-107">
              🔒 Pago 100% seguro | 📥 Descarga inmediata
            </p>
            <p className="text-xs text-gray italic" data-id="element-108">
              ⚕️ El contenido es informativo y no reemplaza consejo médico
              profesional.
            </p>
          </div>
        </div>
      </div>
    </section>;
}